
import { Options, Vue } from "vue-class-component";
import { routeChoice } from "../data/functions";
import Button from "./Button.vue";

@Options({
  components: {
    Button,
  },
  props: {
    date: String,
    hour: String,
    place: String,
    link: String,
    name: String,
    event: Object,
  },
})
export default class EventSchedule extends Vue {
  date!: string;
  hour!: string;
  place!: string;
  link!: string;
  name!: string;
  event!: object;
  routeChoice = routeChoice;
}
